import { lazy } from "react";
import { Navigate } from "react-router-dom";

/**** Layouts *****/
const AppLayout = lazy(() => import("./containers/AppLayout.js"));
const AuthLayout = lazy(() => import("./containers/AuthLayout.js"));

/***** Pages *****/
const LogIn = lazy(() => import("./pages/LoginPage.js"));
const Users = lazy(() => import("./pages/UsersPage.js"));
const Register = lazy(() => import("./pages/RegisterPage.js"));
const Settings = lazy(() => import("./pages/SettingsPage.js"));
const Profile = lazy(() => import("./pages/ProfilePage.js"));
const Groups = lazy(() => import("./pages/GroupsPage.js"));
const Centers = lazy(() => import("./pages/CentersPage.js"));
const Readers = lazy(() => import("./pages/ReadersPage.js"));
const ForgotPassword = lazy(() => import("./pages/ForgotPasswordPage.js"));
const NewPassword = lazy(() => import("./pages/NewPasswordPage.js"));
const ActivateAccount = lazy(() => import("./pages/ActivateAccountPage.js"));

/***** Routes *****/
const ThemeRoutes = [
  {
    path: "/",
    element: <AuthLayout />,
    children: [
      { path: "", element: <Navigate to="/login" /> },
      { path: "/login", exact: true, element: <LogIn /> },
      { path: "/forgot-password", exact: true, element: <ForgotPassword /> },
      { path: "/new-password", exact: true, element: <NewPassword /> },
      { path: "/account/activate", exact: true, element: <ActivateAccount /> },
      { path: "*", element: <LogIn /> },
    ],
  },
  {
    path: "/",
    element: <AppLayout />,
    children: [
      { path: "/dashboard", exact: true, element: <Users /> },
      { path: "/dashboard/profile", exact: true, element: <Profile /> },
      { path: "/dashboard/groups", exact: true, element: <Groups /> },
      { path: "/dashboard/centers", exact: true, element: <Centers /> },
      { path: "/dashboard/users", exact: true, element: <Users /> },
      { path: "/dashboard/readers", exact: true, element: <Readers /> },
      { path: "/dashboard/users/new", exact: true, element: <Register /> },
      { path: "/dashboard/settings", exact: true, element: <Settings /> },
      { path: "/dashboard/*", element: <Users /> },
    ],
  },
];

export default ThemeRoutes;
